// Module
var code = `<div class="jumbotron-surface service-announcement-edit-surface">

  <div class="jumbotron-panel-head">
    <span class="jumbotron-heading" ng-if="!\$ctrl.edit">Create new Service Announcement</span>
    <span class="jumbotron-heading" ng-if="\$ctrl.edit">Edit Service Announcement</span>

    <div class="service-announcement-edit-actions">
      <back-button default-state="manager.library" class="btn btn-sm btn-outline-secondary"></back-button>
    </div>
  </div>

  <form name="editForm" class="service-announcement-edit-body" ng-submit="\$ctrl.submit(editForm.\$valid)">

    <div class="row g-3">
      <div class="col-12">
        <label for="name" class="jumbotron-field-label form-label">Name</label>
        <input id="name" type="text" class="form-control form-control-sm" ng-model="\$ctrl.item.name"
          placeholder="Give it a name" required="required" minlength="1" />
      </div>

      <div class="col-12">
        <label for="headline" class="jumbotron-field-label form-label">Headline</label>
        <input id="headline" type="text" class="form-control form-control-sm" ng-model="\$ctrl.item.headline"
          required="required" minlength="1" />
      </div>

      <div class="col-12">
        <label for="body" class="jumbotron-field-label form-label">Body</label>
        <textarea id="body" type="text" class="form-control form-control-sm" ng-model="\$ctrl.item.body" rows="5"
          required="required" minlength="1"></textarea>
      </div>
    </div>

    <div class="service-announcement-edit-footer">
      <button type="button" class="btn btn-sm btn-discreet-danger service-announcement-edit-remove"
        ng-if="\$ctrl.edit" ng-click="\$ctrl.remove()" ng-disabled="\$ctrl.item.sceneCollections">
        <i class="far fa-trash-can" aria-hidden="true"></i>
        <span>Delete</span>
      </button>
      <button type="submit" class="btn btn-sm btn-primary"
        ng-disabled="\$ctrl.item.name.length === 0 || \$ctrl.item.headline.length === 0 || \$ctrl.item.body.length === 0 || ((\$ctrl.item.name === \$ctrl.org.name) &amp;&amp; (\$ctrl.item.headline === \$ctrl.org.headline) &amp;&amp; (\$ctrl.item.body === \$ctrl.org.body))">
        <span ng-if="!\$ctrl.edit">Add</span>
        <span ng-if="\$ctrl.edit">Save</span>
      </button>
    </div>
  </form>
</div>
`;
// Exports
export default code;